import { lastValueFrom, Observable } from 'rxjs';
import { HIERARCHY_ROOT_ID } from './types';
export class SiteWiseAssetSession {
    constructor(processor) {
        this.processor = processor;
    }
    _requestAssetSummary(query) {
        return new Observable((observer) => {
            this.processor.getAssetSummary(query, observer);
        });
    }
    _requestAssetModel(query) {
        return new Observable((observer) => {
            this.processor.getAssetModel(query, observer);
        });
    }
    _requestAssetPropertyValue(query) {
        return new Observable((observer) => {
            this.processor.getAssetPropertyValue(query, observer);
        });
    }
    _requestRootAssets() {
        return new Observable((observer) => {
            const query = {
                assetHierarchyId: HIERARCHY_ROOT_ID,
            };
            this.processor.getAssetHierarchy(query, observer);
        });
    }
    _requestAssetHierarchy(query) {
        return new Observable((observer) => {
            this.processor.getAssetHierarchy(query, observer);
        });
    }
    fetchAssetHierarchy(query) {
        return lastValueFrom(this._requestAssetHierarchy(query));
    }
    fetchAssetModel(query) {
        return lastValueFrom(this._requestAssetModel(query));
    }
    fetchAssetPropertyValue(query) {
        return lastValueFrom(this._requestAssetPropertyValue(query));
    }
    fetchAssetSummary(query) {
        return lastValueFrom(this._requestAssetSummary(query));
    }
    fetchRootAssets() {
        return lastValueFrom(this._requestRootAssets());
    }
    async describeModeledDataStream(input) {
        return this.processor.describeModeledDataStream(input);
    }
    requestAssetHierarchy(query, observer) {
        return this._requestAssetHierarchy(query).subscribe(observer);
    }
    requestAssetModel(query, observer) {
        return this._requestAssetModel(query).subscribe(observer);
    }
    requestAssetPropertyValue(query, observer) {
        return this._requestAssetPropertyValue(query).subscribe(observer);
    }
    requestAssetSummary(query, observer) {
        return this._requestAssetSummary(query).subscribe(observer);
    }
    requestRootAssets(observer) {
        return this._requestRootAssets().subscribe(observer);
    }
    /**
     * Close the session, causes all requests to be terminated
     */
    close() {
        // complete all observables in the request queue
    }
}
